import { z } from 'zod';

export type VideoIntegrationMetadataPayload = z.infer<typeof videoIntegrationMetadataPayloadSchema>;

/**
 * Vendor-specific configuration accepted when creating or updating an integration.
 *
 * Unlike the metadata on `videoIntegrationSchema`, dates stay ISO strings here: this config is
 * handed to the video integration service untouched rather than being read into the domain.
 */
export const videoIntegrationMetadataPayloadSchema = z.union([
  /** pixellot */
  z.object({ tenantName: z.string() }),
  /** playsight */
  z.object({ scopes: z.array(z.string()) }),
  /** synergy */
  z.object({ token: z.string(), tokenExpiresAt: z.iso.datetime() }),
  /** file-upload, labpano, save-my-play and url-upload carry no configuration of their own */
  z.object({}).strict(),
]);
